"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledWithTheme = void 0;

var _styled2 = _interopRequireDefault(require("@emotion/styled"));

// Re-export emotion's `styled` with Stencil specific types
var styledWithTheme = _styled2.default;
exports.styledWithTheme = styledWithTheme;